import { jsonPost } from '../json-request';
import type { ValidatedApiClient } from '../types/api-client';
import { pinnedModsResponseSchema, trainerHistorySchema } from './schema';

export const createTrainersApi = ({ validatedFetch }: ValidatedApiClient) => ({
    getHistoryForGame: (gameId: string) =>
        validatedFetch(trainerHistorySchema, `/v3/games/${encodeURIComponent(gameId)}/trainers`),

    updatePinnedMods: (gameId: string, modUuids: readonly string[]) =>
        validatedFetch(
            pinnedModsResponseSchema,
            `/v3/user/game/${encodeURIComponent(gameId)}/pinned_mods`,
            new URLSearchParams(),
            jsonPost({ data: modUuids }),
        ),
});
